<ion-select
  [label]="getLabel()"
  label-placement="floating"
  fill="outline"
  (ionChange)="selectedUserChanged.emit($event.detail.value)"
  mode="md"
  [multiple]="multiple"
  interface="popover"
  [value]="getPreselectedUser() | async"
  [disabled]="disabled"
>
  @if (showAllEntry) {
  <ion-select-option [value]="null">{{
    "user.all" | translate
  }}</ion-select-option>
  } @for (user of this.filteredUsers | async; track user) {
  <ion-select-option [value]="user.userName"
    >{{ user.firstName }} {{ user.lastName }}</ion-select-option
  >
  }
</ion-select>
